import { render, staticRenderFns } from "./CombineGroup.vue?vue&type=template&id=13820186&scoped=true"
import script from "./CombineGroup.vue?vue&type=script&lang=js"
export * from "./CombineGroup.vue?vue&type=script&lang=js"
import style0 from "./CombineGroup.vue?vue&type=style&index=0&id=13820186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13820186",
  null
  
)

export default component.exports